export default __webpack_public_path__ + "static/media/image-speaker-zx9.86316905.png";